import { createI18n, I18nT } from 'vue-i18n';
import getEnv from '@/utils/env';

function loadLocaleMessages() {
  const locales = require.context(
    '../assets/locales/home',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );
  /**
   * Import all the locales for sm capability module
   */
  const smLocales = require.context(
    '../assets/locales/sm',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );

  /**
   * Import all the locales for k8 monitoring capability module
   */
  const k8Locales = require.context(
    '../assets/locales/k8',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );
  const apmLocales = require.context(
    '../assets/locales/apm',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );

  const cloudLocales = require.context(
    '../assets/locales/cloud',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );
  /**
   * Import all the locales for vm monitoring capability module
   */
  const vmLocales = require.context(
    '../assets/locales/vm',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );

  /**
   * Import all the locales for Log monitoring capability module
   */
  const logLocales = require.context(
    '../assets/locales/log',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );

  const analyticsLocales = require.context(
    '../assets/locales/analytics',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );

  const notificationLocales = require.context(
    '../assets/locales/notification',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );

  const databaseLocales = require.context(
    '../assets/locales/database',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );

  const alertLocales = require.context(
    '../assets/locales/alert',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );

  const settingsLocales = require.context(
    '../assets/locales/setting',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );

  /**
   * Import all the locales for Mq monitoring capability module
   */
  const mqLocales = require.context(
    '../assets/locales/mq',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );

  /**
   * Import all the locales for browser monitoring capability module
   */
  const browserLocales = require.context(
    '../assets/locales/browser',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );

  const usageLocales = require.context(
    '../assets/locales/usage',
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i,
  );

  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });

  /**
   * Add the K8 monitoring locales to the default locales
   */
  k8Locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], k8Locales(key));
    }
  });
  apmLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], apmLocales(key));
    }
  });

  cloudLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], cloudLocales(key));
    }
  });

  /**
   * Add the vm monitoring locales to the default locales
   */
  vmLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], vmLocales(key));
    }
  });

  /** Add the sm locales to the default locales
   */
  smLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], smLocales(key));
    }
  });

  /**
   * Add the log monitoring locales to the default locales
   */
  logLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], logLocales(key));
    }
  });

  analyticsLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], analyticsLocales(key));
    }
  });

  databaseLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], databaseLocales(key));
    }
  });

  settingsLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], settingsLocales(key));
    }
  });

  notificationLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], notificationLocales(key));
    }
  });

  alertLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], alertLocales(key));
    }
  });
  /**
   * Add the mq monitoring locales to the default locales
   */
  mqLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], mqLocales(key));
    }
  });

  /**
   * Add the browser monitoring locales to the default locales
   */
  browserLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], browserLocales(key));
    }
  });

  usageLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      Object.assign(messages[locale], usageLocales(key));
    }
  });

  return messages;
}

const i18n = createI18n({
  allowComposition: true,
  locale:
    getEnv('VUE_APP_I18N_LOCALE') || process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale:
    getEnv('VUE_APP_I18N_FALLBACK_LOCALE') ||
    process.env.VUE_APP_I18N_FALLBACK_LOCALE ||
    'en',
  messages: loadLocaleMessages(),
  silentTranslationWarn: true,
});

export default i18n;

export { I18nT };
